export default __webpack_public_path__ + "static/media/code.959e773b.svg";